const setComponentLoaded = (state, isLoaded) => {
  state.componentLoaded = isLoaded;
};

export default {
  setComponentLoaded
};
